import React, { useCallback } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import clsx from 'clsx';
import { Controller } from 'react-hook-form';
import useStyles from './styles';

type Options = {
  id: number | string;
  label: string;
  description?: string;
};

type Props = {
  label?: string;
  name: string;
  disabled?: boolean;
  options: Options[];
  blockedIds?: string[] | number[];
};

const ReactFormRadioGroup = ({
  label, name, options, blockedIds,
}: Props) => {
  const classes = useStyles();

  const renderLabel = useCallback((labelText: string, description?: string) => {
    if (description) {
      return (
        <div>
          <div>{labelText}</div>
          <div className={classes.labelDescription}>{description}</div>
        </div>
      );
    }
    return labelText;
  }, [classes]);

  return (
    <Controller
      name={name}
      render={(props) => (
        <FormControl component="fieldset">
          {label && (<FormLabel component="legend">{label}</FormLabel>)}
          <RadioGroup
            name={name}
            value={props.value}
            {...props}
          >
            {options.map((option) => (
              <div key={option.id}>
                <FormControlLabel
                  value={option.id}
                  control={(
                    <Radio
                      disabled={blockedIds && blockedIds.includes(option.id as never)}
                      classes={{
                        root: clsx(classes.radioRoot, { [classes.radioRootWithDesc]: Boolean(option.description) }),
                      }}
                      checked={props.value === option.id}
                    />
                  )}
                  label={renderLabel(option.label, option.description)}
                  classes={{
                    root: clsx(classes.labelRoot, { [classes.labelRootWithDesc]: Boolean(option.description) }),
                    label: classes.label,
                  }}
                />
              </div>
            ))}
          </RadioGroup>
        </FormControl>
      )}
    />
  );
};
export default ReactFormRadioGroup;
